import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const PaymentsAsync = lazy(() => import('./ui/Payments'));

export const Payments = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <PaymentsAsync />
    </Suspense>
  );
};
